import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/App.css"; // Import global styles

const SignUpContainer: React.FC = () => {
  const navigate = useNavigate();

  // Handlers to navigate to respective signup pages
  const handleClinicSignup = () => navigate("/signup/clinic");
  const handleProviderSignup = () => navigate("/signup/provider");

  return (
    <div className="signup-container">
      <h2>Sign Up</h2>
      <p>Select your role to get started:</p>

      <div className="signup-buttons">
        <button onClick={handleClinicSignup} className="clinic-button">
          <span className="button-label">Clinic Manager</span>
          <span className="button-subtext">
            Manage prescriptions & patients
          </span>
        </button>

        <button onClick={handleProviderSignup} className="provider-button">
          <span className="button-label">Provider</span>
          <span className="button-subtext">
            Review and approve prescriptions
          </span>
        </button>
      </div>
    </div>
  );
};

export default SignUpContainer;
